export default "__VITE_ASSET__DkhYwSVC__"